import {addErrorClass, addLoadingClass, addSuccessClass} from "cronus-theme/default/global/js/utilities/updateClasses";

export function copyTextToClipboard(text, success = () => {
}, error = () => {
}) {
    if (!navigator.clipboard) {
        try {
            const textarea = document.createElement('textarea');
            textarea.value = text;
            textarea.style.position = 'fixed';
            textarea.style.opacity = '0';
            document.body.appendChild(textarea);
            textarea.focus();
            textarea.select();
            document.execCommand('copy');
            document.body.removeChild(textarea);
            success();
        } catch (err) {
            console.error('Fallback: Could not copy text: ', err);
            error();
        }
        return;
    }
    navigator.clipboard.writeText(text).then(function () {
        success();
    }, function (err) {
        console.error('Async: Could not copy text: ', err);
        error();
    });
}

export function triggerDCCopyLink(query = document.querySelectorAll('.js-dcCopyLink')) {
    let timeoutCopy = false;
    for (const link of query) {
        link.addEventListener("click", function (e) {
            addLoadingClass(link);
            clearTimeout(timeoutCopy);
            timeoutCopy = setTimeout(function () {
                const dataLink = link.dataset.link;
                if (dataLink) {
                    copyTextToClipboard(dataLink, function () {
                        addSuccessClass(link);
                    }, function () {
                        addErrorClass(link);
                    });
                }
            }, 500);
            e.preventDefault();
        });
    }
}